(function() {
  var products = window.fybProducts || [];
  var skinTags = [];
  var scentTags = [];
  var step1 = document.getElementById('fyb-step-1');
  var step2 = document.getElementById('fyb-step-2');
  var step3 = document.getElementById('fyb-step-3');
  var results = document.getElementById('fyb-results');
  var grid = document.getElementById('fyb-results-grid');

  if (!step1) return;

  function showStep(step) {
    [step1, step2, step3, results].forEach(function(s) { s.style.display = 'none'; });
    step.style.display = 'block';
  }

  function matchCount(p, tags) {
    if (tags.length === 0) return true;
    return tags.some(function(t) { return p.tags.indexOf(t) !== -1; });
  }

  function renderResults(occasionTags) {
    var levels = [
      function(p) { return matchCount(p, skinTags) && matchCount(p, scentTags) && matchCount(p, occasionTags); },
      function(p) { return matchCount(p, scentTags) && matchCount(p, occasionTags); },
      function(p) { return matchCount(p, scentTags); },
      function(p) { return true; }
    ];
    var matches = [];
    for (var i = 0; i < levels.length; i++) {
      matches = products.filter(levels[i]);
      if (matches.length > 0) break;
    }
    matches = matches.slice(0, 8);
    grid.innerHTML = '';
    if (matches.length === 0) {
      grid.innerHTML = '<p class="fyb-empty">We could not find an exact match, but browse our <a href="/collections/signature">Signature Collection</a> for more options!</p>';
    } else {
      matches.forEach(function(p) {
        var card = document.createElement('div');
        card.className = 'fyb-card';
        var imgTag = p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '<div class="fyb-noimg"></div>';
        var badges = '';
        if (p.collection) { badges += '<span class="fyb-badge">' + p.collection + '</span>'; }
        if (p.fragrance) { badges += '<span class="fyb-badge">' + p.fragrance + '</span>'; }
        card.innerHTML = '<a href="' + p.url + '">' + imgTag + '<p class="fyb-card-title">' + p.title + '</p><p class="fyb-card-price">' + p.price + '</p></a><div class="fyb-badges">' + badges + '</div>';
        grid.appendChild(card);
      });
    }
    showStep(results);
  }

  step1.querySelectorAll('.fyb-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      skinTags = btn.getAttribute('data-tags').split(',').filter(Boolean);
      showStep(step2);
    });
  });

  document.getElementById('fyb-back-1').addEventListener('click', function(e) {
    e.preventDefault();
    showStep(step1);
  });

  document.getElementById('fyb-back-2').addEventListener('click', function(e) {
    e.preventDefault();
    showStep(step2);
  });

  document.getElementById('fyb-restart').addEventListener('click', function(e) {
    e.preventDefault();
    skinTags = [];
    scentTags = [];
    showStep(step1);
  });

  step2.querySelectorAll('.fyb-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      scentTags = btn.getAttribute('data-tags').split(',').filter(Boolean);
      showStep(step3);
    });
  });

  step3.querySelectorAll('.fyb-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var occasionTags = btn.getAttribute('data-tags').split(',').filter(Boolean);
      renderResults(occasionTags);
    });
  });
})();
